import { gql } from '@apollo/client';

export default gql`
  mutation rollbackDiscountCodeRedemption($bookingReference: String!, $discountCode: String!) {
    rollbackDiscountCodeRedemption(bookingReference: $bookingReference, discountCode: $discountCode)
  }
`;
